import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { useFormTcfVendor, useI18n } from "../../../../../contexts";
const FormTcfVendorFieldGeneralProvider = ()=>{
    const { __ } = useI18n();
    const { vendor: { id, name } } = useFormTcfVendor();
    return /*#__PURE__*/ _jsx(Form.Item, {
        label: __("Provider"),
        children: /*#__PURE__*/ _jsx(Input, {
            value: name,
            readOnly: true,
            addonAfter: __("Vendor ID: %d", id)
        })
    });
};
export { FormTcfVendorFieldGeneralProvider };
